import { getCarListV2, FuzzySearch } from '@/api/domain/cars'
import selectOption from '@/store/dict/selectOptionDict'
import { dict2list } from '@/utils/index'
import { h } from 'vue'
import { TABS, tabList } from './index'
import { operateMaxShowLength } from '@/store/dict/config'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'
// 退出运营配置
export const OutCarConfig = ({ table, operations, cityList }) => {
  return {
    formData: {
      list: [{
        el: 'select',
        itemConfig: {
          label: '车牌号',
          prop: 'plateNo',
        },
        elConfig: {
          remote: true,
          clearable: true,
          filterable: true,
          reserveKeyword: true,
          defaultFirstOption: true,
          remoteMethod: (query) => {
            const keyWords = query.trim()
            if (keyWords.length > 3) {
              FuzzySearch({
                plateNo: query.trim(),
                state: 1,
              }).then((res) => {
                const { data } = res
                table.value.setItemData({
                  elConfigKey: 'list',
                  key: 'plateNo',
                  data: data || [],
                })
              })
            }
          },
          placeholder: '请输入',
          options: {
            label: 'plateNo',
            value: 'id',
            list: [],
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '车辆ID',
          prop: 'id',
        },
        directives: [{ name: 'number', arg: 'integer', value: 18 }],
        elConfig: {
          clearable: true,
          placeholder: '请输入车辆ID',
        },
      }, {
        itemConfig: {
          prop: 'brandSeriesModel',
        },
        elConfig: {
          showModel: true,
          filterScene: CAR_MODEL_FILTER_SCENE.EXIT_OPERATION,
        },
        render: 'CarBrandSeriesModel',
      }, {
        el: 'select',
        itemConfig: {
          label: '运营城市',
          prop: 'adcode',
        },
        elConfig: {
          clearable: true,
          filterable: true,
          reserveKeyword: true,
          defaultFirstOption: true,
          placeholder: '请选择',
          options: {
            label: 'city',
            value: 'adcode',
            list: cityList,
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: 'VIN码',
          prop: 'vin',
        },
        elConfig: {
          clearable: true,
          maxlength: 18,
          placeholder: '请输入',
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '车辆创建时间',
          prop: 'carCreateTime',
        },
        elConfig: {
          format: 'yyyy-MM-dd',
          'value-format': 'yyyy-MM-dd HH:mm:ss',
          type: 'daterange',
          'range-separator': '至',
          'start-placeholder': '开始日期',
          'end-placeholder': '结束日期',
          clearable: true,
          'default-time': ['00:00:00', '23:59:59'],
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '处置时间',
          prop: 'times',
        },
        elConfig: {
          format: 'yyyy-MM-dd',
          'value-format': 'yyyy-MM-dd HH:mm:ss',
          type: 'daterange',
          'range-separator': '至',
          'start-placeholder': '开始日期',
          'end-placeholder': '结束日期',
          clearable: true,
          'default-time': ['00:00:00', '23:59:59'],
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '处置方式',
          prop: 'disposalMethodList',
        },
        elConfig: {
          placeholder: '请选择',
          clearable: true,
          multiple: true,
          filterable: false,
          options: {
            label: 'label',
            value: 'value',
            list: dict2list(selectOption.disposalMethodList),
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '能源类型',
          prop: 'energyType',
        },
        elConfig: {
          clearable: true,
          placeholder: '请选择',
          filterable: false,
          options: {
            label: 'name',
            value: 'code',
            list: [],
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '电池冷却方式',
          prop: 'coolingMode',
        },
        elConfig: {
          clearable: true,
          placeholder: '请选择',
          filterable: false,
          options: {
            label: 'name',
            value: 'code',
            list: [],
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '处置原因',
          prop: 'fuzzyExitReason',
        },
        elConfig: {
          maxlength: '18',
          placeholder: '请输入',
          clearable: true,
        },
      }],
      exportData: {
        // 导出模板，用于查找对应的导出方法
        // export.js文件中需存在以'export{{exportTemplate}}'命名的导出方法，例如：exportReturnCarOrderList
        exportTemplate: 'CarList',
        // 导出的文件名称
        filename: '退出运营车辆列表.xlsx',
        // 资源权限（可选）
        permissionName: 'vehicle_list_export',
      },
      dealWithSearch: (params) => {
        // 品牌车型车系参数处理
        const { brandSeriesModel, carCreateTime, times } = params
        if (brandSeriesModel) {
          const { brandId, seriesId, modelId } = brandSeriesModel
          params.seriesId = seriesId
          params.modelId = modelId
          params.brandId = brandId
        }
        // 创建时间参数处理
        if (carCreateTime) {
          const [carCreateStartDate, carCreateEndDate] = carCreateTime
          params.carCreateStartDate = carCreateStartDate
          params.carCreateEndDate = carCreateEndDate
        }
        // 处置时间参数处理
        if (times) {
          params.exitStartDate = times[0]
          params.exitEndDate = times[1]
        }
        delete params.carCreateTime
        delete params.brandSeriesModel
        delete params.times
        // 添加tab参数
        const tabParams = tabList[TABS.OutCar].params
        params = {
          ...params,
          ...tabParams,
        }
        return params
      },
      customizeReset: () => {
        table.value.setItemData({
          elConfigKey: 'value',
          key: 'brandSeriesModel',
          data: {},
        })
      },
    },
    tableData: {
      columns: [{
        name: 'carId',
        columnProps: {
          prop: 'carId',
          label: '车辆ID',
          width: 100,
        },
        render({ row }) {
          return h('span', {
            class: 'cursor-point',
            style: {
              color: '#276BEC',
            },
            on: {
              click: () => {
                const { viewDetail } = operations
                viewDetail.judgePermission && viewDetail.handler(row)
              },
            },
          }, row.id)
        },
      }, {
        name: 'plateNo',
        columnProps: {
          prop: 'plateNo',
          label: '车牌号',
          width: 100,
        },
      }, {
        name: 'vin',
        columnProps: {
          prop: 'vin',
          label: 'VIN码',
        },
      }, {
        name: 'city',
        columnProps: {
          prop: 'city',
          label: '运营城市',
        },
      }, {
        name: 'brand',
        columnProps: {
          prop: 'brand',
          label: '品牌',
        },
      }, {
        name: 'series',
        columnProps: {
          prop: 'series',
          label: '车系',
        },
      }, {
        name: 'modelName',
        columnProps: {
          prop: 'modelName',
          label: '车型',
          width: 160,
        },
      }, {
        name: 'engineNo',
        columnProps: {
          prop: 'engineNo',
          label: '发动机号',
        },
      },
      {
        name: 'energyTypeDesc',
        columnProps: {
          prop: 'energyTypeDesc',
          label: '能源类型',
          width: 120,
        },
      },
      {
        name: 'coolingModeDesc',
        columnProps: {
          prop: 'coolingModeDesc',
          label: '电池冷却类型',
          width: 120,
        },
      }, {
        name: 'gmtCreate',
        columnProps: {
          prop: 'gmtCreate',
          label: '车辆创建时间',
          width: 100,
        },
      }, {
        name: 'userName',
        columnProps: {
          prop: 'userName',
          label: '所属车管',
        },
      }, {
        name: 'exitDate',
        columnProps: {
          prop: 'exitDate',
          label: '处置时间',
        },
      }, {
        name: 'exitReason',
        columnProps: {
          prop: 'exitReason',
          label: '处置原因',
        },
      }, {
        name: 'disposalMethod',
        columnProps: {
          prop: 'disposalMethod',
          label: '处置方式',
        },
        getText: ({ row }) =>
          selectOption.disposalMethodList[row.disposalMethod],
      }, {
        name: 'mortgagor',
        columnProps: {
          prop: 'mortgagor',
          label: '车辆抵押方',
          width: 150,
        },
      }, {
        name: 'licenseOwner',
        columnProps: {
          prop: 'licenseOwner',
          label: '行驶证所有人',
          width: 150,
        },
      }, {
        name: 'operate',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        type: 'operate',
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          const ops = []
          const op = operations.restoreOperate
          op.judgePermission(row) && ops.push({
            name: 'restoreOperate',
            label: op.label,
            action: () => op.handler(row),
          })
          return ops
        },
      }],
      apiFn: getCarListV2,
    },
  }
}
